(function ( $ ) {

   $.fn.formHeight = function() {
        var $this = $(this),
        $valid = $('.js-contact-valid');

        $valid.height($this.height());
   }

}( jQuery ));

(function ( $ ) {

   $.fn.contactForm = function( options ) {
     var settings = $.extend({
         error: '',
         success: ''
     }, options );
     var that = this;

     function submitForm() {
        $('[data-error]').removeClass('has-error');
        that.find('button[type="submit"]').prop('disabled', 'disabled');
        var data = new FormData(that[0]);
        data.append('action', 'contact_form');
        console.log(data);

         $.ajax({
             url: ajaxurl,
             data: data,
             processData: false,
             contentType: false,
             type: 'POST',
             beforeSend: function() {
                 $('.js-progress').addClass('animated');
             },
             success:function(data){
               // that.find('button[type="submit"]').prop('disabled', 'disabled');
               // that.addClass('is-valid');
               that.addClass('hidden');
                $('.js-contact-error').hide();
                setTimeout( function() {
                    $('.js-contact-valid').addClass('show');
                }, 400);
                $('.js-progress').removeClass('animated');
            },
            error: function(xhr, status, error) {
                console.log(xhr.responseJSON);
                Object.keys(xhr.responseJSON).map(function(key) {
                    $('[data-error="' + key + '"]').addClass('has-error');
                    $('[data-error="' + key + '"]').parent().velocity({scale:"0.97"}).velocity({scale:"1"}, {easing: "spring"});
                });
                that.find('button[type="submit"]').prop('disabled', false);
                $('.js-contact-error').fadeIn();
                $('.js-progress').removeClass('animated');
           }
         });
       }

     if (this.length) {
       return this.submit(function(e){
         e.preventDefault();
         submitForm();
       });
     }
   }

}( jQuery ));

$(function() {

    $('.js-form-height').formHeight();


 $('#js-contact-form').contactForm({
   success: '.js-form-success'
 });
});
